export const ColourblindnessStatId = '9-12-0';

export const DyscalculiaStatId = '9-12-1';

export const SPEED_DOMAIN_STAT = '9-5-1';
export const REASONING_DOMAIN_STAT = '9-5-2';
export const ATTENTION_DOMAIN_STAT = '9-5-3';
export const MEMORY_DOMAIN_STAT = '9-5-4';
